import './Account.css';
import { useState, useEffect, useCallback } from 'react';
import AccountMain from './AccountMain';
import AccountInDocket from './AccountInDocket';
import { fetchPostAufa, generateInvoice, generateTickets, generateTicketsDownload, generateTicketsEmail } from '../../../../faetures/fetch';
import regx from '../../../../functions/regx';
import Massage from "../../../design/Massage";
import { startAccount } from './functionAccount';
import Loader from '../../../../faetures/Loader/Loader';


export default function AppAccount({
    names, // list of name in aufaDocket
    data, // data of AufaDocket
    projectId, // project id
    price, // price of all data 
    setPrice, // update price
    num_of_docket, // num of main docket
    namesInvoices,
    setNamesInvoices,
    dataToAccount, // The information loaded on the initial load, such as email, status, etc.
    setDataToAccount,
    updateDataDocketList,
    updateDataDocketObject,
    setClose,
    idAufa,
    settingProject,
    setDataMain,
    agreeToContinue,
    setAgreeToContinue,
    setCloseMain }) {

    const [openMain, setOpenMain] = useState(false); // opent the payment
    const [massage, setMassage] = useState({ text: '', open: false }); // popup massage
    const [token, setToken] = useState('');  // token from server, this saves the price for 10 minute / 24 hours
    const [dataAccount, setDataAccount] = useState({ numOfNames: 0, sum: 0, sumR: 0, sumInvoices: 0, sumToClose: 0 });
    const [namesPaid, setNamesPaid] = useState({});  // how much each person paid
    const [saveOrPay, setSaveOrPay] = useState(false);  // The payment is false; retention for 24 hours is true.
    const [textSavePay, setTextSavePay] = useState({ save: false, pay: '', allowedToSave: false });
    const [ticketAction, setTicketAction] = useState("");
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (dataToAccount.email == '' && Object.keys(names).length > 0) {
            console.log("in if")
            fetchPostAufa('get-email-phone', Object.keys(names))
                .then((res) => {
                    console.log(res);
                    dataToAccount.email = res.message.email;
                    dataToAccount.phone = res.message.phone;

                })
                .catch(err => {
                    console.log(err)
                })
        }

    }, [names]);


    useEffect(() => {
        startAccount(dataToAccount, setToken, textSavePay, setTextSavePay, setNamesPaid);
    }, [dataToAccount])


    useEffect(() => {
        let num = 0;
        let sumInvoices = 0;
        let sumR = 0;

        Object.values(price).map((numPrice) => {
            num += Number(numPrice);
        })

        if (settingProject && Date.now() < (settingProject['dateToRegistrationFee'] * 1000) && settingProject['priceToRegistrationFee'] < num) {
            sumR = settingProject['priceToRegistrationFee'];
        } else {
            sumR = num;
        }

        let sumToClose = Object.keys(names).length * sumR;

        Object.values(namesPaid).map((numSum) => {
            numSum = Number(numSum);
            sumInvoices += numSum;

            (numSum <= dataAccount.sumR) ? (sumToClose -= numSum) : (sumToClose -= sumR);
        })

        setDataAccount({ sumR: sumR, sum: num, numOfNames: Object.keys(names).length, sumInvoices: Math.round(sumInvoices), sumToClose: sumToClose });

    }, [price, names, namesPaid])


    function checkDataAndWriteMassage(send, get) {

        if (dataAccount.numOfNames === 0) {
            setMassage({ open: true, text: "יש להוסיף שמות" });
            return;
        }
        if (Object.keys(data).length < 1 && dataToAccount.status === 5) {
            setMassage({ open: true, text: "יש להוסיף מוצרים" });
            return;
        }

        if (get) {
            return true;
        }

        if (!agreeToContinue) {
            setMassage({ open: true, text: "יש ללחוץ על קבל מחיר" });
            return;
        }

        if (send) {

            if (!(regx('email', dataToAccount.email, false) && regx('phone', dataToAccount.phone, false))) {
                setMassage({ open: true, text: "אמייל וטלפון חובה לסגירת ההזמנה !" });
                return;
            }
            if (!(Math.floor(dataAccount.sumToClose) <= 0 || saveOrPay) && dataToAccount.status !== 2 && dataToAccount.status !== 1) {
                setMassage({ open: true, text: "יש לסיים תשלום או לשמור ל 24 שעות" });
                return;
            }
        }

        return true;
    }


    function organizeDataToSendToServer() {
        const data_to_send = { project: projectId, token: token || '', p: dataAccount.numOfNames, data: {}, price: dataAccount.sum, idAufa: idAufa, status: dataToAccount.status };

        ('fa' in data) && (data_to_send['data']['fa'] = data['fa'][0]);
        ('fr' in data) && (data_to_send['data']['fr'] = data['fr'][0]);
        ('ca' in data) && (data_to_send['data']['ca'] = data['ca'][0]);
        ('cr' in data) && (data_to_send['data']['cr'] = data['cr'][0]);

        return data_to_send;
    }

    function updateDataFromServer(resolve) {

        if (typeof resolve === 'string') {
            setMassage({ open: true, text: resolve });
            return;
        }

        let agreeToUpdate = true;
        let update_price = {};
        let update_data = {};

        Object.keys(resolve).map((key) => {
            if (typeof resolve[key] === 'number') {
                update_price[key] = resolve[key];
                update_data[key] = data[key];
            } else {
                setMassage({ open: true, text: resolve[key] });
                update_price[key] = 0;
                update_data[key] = data[key];
                agreeToUpdate = false;
            }
        })

        setPrice(update_price);
        setDataMain(update_data);
        return agreeToUpdate;
    }

    function getPriceFromServer() {

        if (checkDataAndWriteMassage(false, true)) {
            let data_to_send = organizeDataToSendToServer();
            data_to_send['token'] = "";

            fetchPostAufa('getPriceOfData', data_to_send).then((resolve) => {

                if (typeof resolve === 'object' && resolve !== null) {
                    setToken(resolve['token']);

                    let agreeToUpdate = updateDataFromServer(resolve['data']);

                    agreeToUpdate && setAgreeToContinue(true);
                }
            });
        }
    }

    const saveAndSendToServer = () => {
        console.log("saveAndSendToServer");
        if (checkDataAndWriteMassage(true, false)) {

            let data_to_send = {
                names: Object.keys(names), numOfDocket: num_of_docket, email: dataToAccount.email, phone: dataToAccount.phone, save: saveOrPay, data: organizeDataToSendToServer(),
                sum: dataAccount.sum, invoices: namesInvoices, idAufa: idAufa
            };


            fetchPostAufa('saveAufa', data_to_send).then((resolve) => {

                if (typeof resolve === 'object' && resolve !== null) {
                    if (resolve['status'] === 1) {
                        setMassage({ open: true, text: "יש שינויים במחיר, יש להקיש שוב על קבל מחיר" });
                    } else if (resolve['status'] === 4) {
                        setMassage({ open: true, text: "שגיאה בשרת, יש לנסות שוב" });
                    } else if (resolve['status'] === 2) {
                        setMassage({ open: true, text: resolve['data'] });
                    } else if (resolve['status'] === 0) {
                        updateDataDocketObject('aufaFlights', resolve['data']);
                        setClose();
                    }
                }
            })
        }
    }

    const senDetailsToInvoice = (invoiceDates) => {
        console.log("senDetailsToInvoice")
        let data_to_send = {
            names: Object.keys(names), numOfDocket: num_of_docket.toString(), email: dataToAccount.email, phone: dataToAccount.phone, save: saveOrPay, data: organizeDataToSendToServer(),
            sum: dataAccount.sum, invoices: namesInvoices, idAufa: idAufa, price: price, dates: invoiceDates
        };
        // console.log("data to send", data_to_send);


        generateInvoice('generate-invoice', data_to_send)
            .then(blob => {
                if (blob.type === 'application/pdf') {
                    const url = URL.createObjectURL(blob);
                    const newWindow = window.open();
                    newWindow.document.write('<html><head><title>חשבונית</title></head><body>');
                    newWindow.document.write('<iframe src="' + url + '" frameborder="0" style="width:100%; height:100%;"></iframe>');
                    newWindow.document.write('</body></html>');
                    newWindow.document.close();
                } else {
                    console.error('Expected PDF but received:', blob.type);
                    alert("עליך להתחבר למערכת");
                }
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });

    }

    function organizeDataToDelete() {
        // console.log("in organizeDataToDelete");
        // Define the keys of interest
        const serviceKeys = ['fa', 'fr', 'ca', 'cr'];

        // Initialize the new object
        let newData = {};

        // Iterate over the service keys
        serviceKeys.forEach((key) => {
            if (data[key] && price[key]) {
                newData[key] = {
                    d: data[key][0], // Service ID
                    p: price[key]    // Service price
                };
            }
        });
        // console.log("new data", newData);
        return newData;
    }

    const deleteAufa = () => {
        // console.log("deleteAufa");
        let dataToSend = {
            p: (Object.keys(names).length) * -1,
            data: organizeDataToDelete(),
            new: false,
            project: projectId,
            token: token || '',
            names: Object.keys(names),
            id_docket: num_of_docket,
            price: dataAccount.sum,
            approved: null,
            idAufa: idAufa
        }


        fetchPostAufa('delete_aufa', dataToSend).then((resolve) => {

            if (typeof resolve === 'object' && resolve !== null) {
                if (resolve['status'] === 4) {
                    setMassage({ open: true, text: "שגיאה במחיקת הזמנה" });
                } else if (resolve['status'] === 0) {
                    setMassage({ open: true, text: "הזמנה נמחקה בהצלחה" });
                    setTimeout(() => {
                        setClose();
                        setCloseMain();
                    }, 2000);
                }
                else if (resolve['status'] === 2)
                    setMassage({ open: true, text: "אין לך הרשאה למחיקת הזמנה" });
                else if (resolve['status'] === 1)
                    setMassage({ open: true, text: "שגיאה במחיקת הזמנה" });

            }
        })
    }

    const sendDetailsToTickets = (action) => {
        setLoading(true);
        console.log("sendDetailsToTickets");
        console.log("action", action);
        // setTicketAction([...ticketAction, action]);
        console.log("ticketAction", ticketAction)
        const keysToInclude = ['fa', 'fr', 'ca', 'cr'];
        const transport = Object.keys(data)
            .filter(key => keysToInclude.includes(key))
            .reduce((acc, key) => {
                acc[key] = data[key][0];
                return acc;
            }, {});

        let tickets_data = {
            names: Object.keys(names),
            transport: transport,
            idAufa: idAufa,
            idDocket: num_of_docket,
            action: action,
            email: dataToAccount.email
        };

        console.log("tickets_data", tickets_data);
        if (action == "download") {
            console.log('action == "download"');
            generateTicketsDownload('generate-tickets', tickets_data)
                .then(async blob => {
                    console.log(blob);

                    // Create a URL for the Blob and trigger the download
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `tickets_${num_of_docket}_${idAufa}.zip`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url); // Clean up the URL object

                    setMassage({ text: "כרטיסים נוצרו בהצלחה", open: true });
                })
                .catch(err => {
                    console.error("Error generating tickets:", err);

                    let errorMessage = "שגיאה ביצירת כרטיסים"; // Default message

                    if (err === 400) {
                        errorMessage = "שגיאה בנתוני הזמנה";
                    } else if (err === 401) {
                        errorMessage = "לא ניתן ליצור כרטיסים עבור הזמנה לא סגורה";
                    } else if (err === 402) {
                        errorMessage = "לא ניתן ליצור כרטיסים עבור הזמנה לא מאושרת";
                    } else if (err === 500) {
                        errorMessage = "שגיאה בנתוני הזמנה";

                    }


                    setMassage({ text: errorMessage, open: true });
                })
                .finally(() => setLoading(false));
        }

        else if (action == "email") {
            generateTicketsEmail('generate-tickets', tickets_data)
                .then(res => {
                    console.log("res", res);
                    if (res.status == 200)
                        setMassage({ text: "מייל נשלח בהצלחה", open: true });
                    else 
                        setMassage({ text: "בעיה בשליחת מייל", open: true });

                })
                .catch(err => {
                    console.error("Error generating tickets in:", err);

                    let errorMessage = "שגיאה בשליחת אימייל"; // Default message

                    if (err === 400) {
                        errorMessage = "שגיאה בנתוני הזמנה";
                    } else if (err === 401) {
                        errorMessage = "לא ניתן ליצור כרטיסים עבור הזמנה לא סגורה";
                    } else if (err === 402) {
                        errorMessage = "לא ניתן ליצור כרטיסים עבור הזמנה לא מאושרת";
                    } else if (err === 500) {
                        errorMessage = "שגיאה בנתוני הזמנה";

                    }


                    setMassage({ text: errorMessage, open: true });
                })
                .finally(() => setLoading(false));
        }
    };

    return (<>
        {
            loading && <Loader></Loader>
        }

        {
            massage.open &&
            <Massage
                text={massage.text}
                setClose={() => setMassage({ open: false, text: "" })}
                animation={true}
            />
        }

        <AccountInDocket
            dataAccount={dataAccount}
            getPriceFromServer={getPriceFromServer}
            setOpenMain={() => setOpenMain(true)}
            inputEmailPhone={{ email: dataToAccount.email, phone: dataToAccount.phone }}
            setEmail={(value) => setDataToAccount({ ...dataToAccount, email: value })}
            setPhone={(value) => setDataToAccount({ ...dataToAccount, phone: value })}
            saveAndSendToServer={saveAndSendToServer}
            saveOrPay={saveOrPay}
            setSaveOrPay={setSaveOrPay}
            agreeToContinue={agreeToContinue}
            setMassage={setMassage}
            textSavePay={textSavePay}
            senDetailsToInvoice={senDetailsToInvoice}
            deleteAufa={deleteAufa}
            sendDetailsToTickets={sendDetailsToTickets}
            setTicketAction={setTicketAction}
        />

        {openMain &&
            <AccountMain
                namesPaid={namesPaid}
                setNamesPaid={setNamesPaid}
                setClose={() => setOpenMain(false)}
                dataAccount={dataAccount}
                num_of_docket={num_of_docket}
                namesInvoices={namesInvoices}
                setNamesInvoices={setNamesInvoices}
                names={names}
                organizeDataToSendToServer={organizeDataToSendToServer}
                setMassage={setMassage}
                updateDataDocketList={updateDataDocketList}
                idAufa={idAufa}
                projectId={projectId}
            />
        }



    </>)
}
